'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
// 加载陌陌的代码
var loadMoMoJs = function loadMoMoJs(id) {
    (function () {
        window.logsMomoUserId = id;
        var jsonpScript = document.createElement('script');
        jsonpScript.type = 'text/javascript';
        var random = Math.ceil(Math.random() * 10);
        jsonpScript.src = 'https://s.momocdn.com/w/u/others/custom/conver/mycustom/converjsonp.js?r=' + random;
        var heads = document.getElementsByTagName('script')[0];
        heads.parentNode.insertBefore(jsonpScript, heads);
    })();
};

exports.default = {
    init: function init(id) {
        loadMoMoJs(id);
    },
    doStatistics: function doStatistics() {
        window.sendLosMeth && window.sendLosMeth('submit');
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@souche-f2e/statistics/dist/channel/momo.js
// module id = jm+r
// module chunks = 11